export const contentAPI = process.env.CONTENT_API;
export const checkoutAPI = process.env.CHECKOUT_API;
export const depictAPI = process.env.DEPICT_API;

export const origin = 'https://stutterheim.com';

export const useLanguageURLRoots = false;

export const paymentMethodsMapping = {
	klarnaCheckout: 'klarna-checkout',
	klarnaOld: 'kreditor_v2',
	adyenCheckout: 'adyen-checkout',
	adyenDropIn: 'adyen-drop-in',
	stripeCheckout: 'stripe-checkout',
	stripePaymentIntents: 'stripe-payment-intents',
};

export const paymentMethodsOrder = [
	'klarna-checkout',
	'adyen-drop-in',
	'dibs',
	'paypal',
];

export const addressFieldOrder = [
	'email',
	'firstName',
	'lastName',
	'company',
	'phoneNumber',
	'address1',
	'address2',
	'zipCode',
	'city',
	'country',
	'state',
];

export const urlRoots = [
	'stutterheim',
];

export const shippingMethodsMapping = {
	ingrid: 'ingrid',
};

export const baseCurrency = {
	EUR: 'AD', // Andorra
	USD: 'NZ', // New Zealand
};
